/**
 * Счётчики сайдбара (бейджи модулей и подпунктов): GET /api/sidebar/counts (A1).
 * Контракт: { desk, decisions, sales, tenders } → number. Сайдбар опрашивает раз в 60 с;
 * ошибки (нет права tender.read, сеть) сайдбар глотает — бейджи некритичны.
 */
import { api } from '../api.js';

export async function fetchSidebarCounts() {
  return api.sidebarCounts();
}
